export default __webpack_public_path__ + "static/media/home.d3dc9bde.png";